import { create } from 'zustand';

interface LoadingState {
  isLoading: boolean;
  isStoreHydrated: boolean;
  setLoading: (loading: boolean) => void;
  setStoreHydrated: (hydrated: boolean) => void;
  hideLoading: () => void;
}

const minDisplayTime = 1000; // 1 second

export const useLoadingStore = create<LoadingState>((set) => {
  let hydrationTime: number | null = null;

  return {
    isLoading: true,
    isStoreHydrated: false,
    setLoading: (loading: boolean) => set({ isLoading: loading }),
    setStoreHydrated: (hydrated: boolean) => {
      if (hydrated) {
        hydrationTime = Date.now();
      }
      set({ isStoreHydrated: hydrated });
    },
    hideLoading: () => {
      const now = Date.now();
      const timeSinceHydration = now - (hydrationTime || now);
      const remainingTime = minDisplayTime - timeSinceHydration;

      if (remainingTime > 0) {
        setTimeout(() => {
          set({ isLoading: false });
        }, remainingTime);
      } else {
        set({ isLoading: false });
      }
    },
  };
});
